// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#modal-reassign .date{text-align:center}#modal-reassign .date>div{display:inline-block}#modal-reassign .date>div.form-row-input{width:auto}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/reassign-modal.vue"],"names":[],"mappings":"AAEC,sBACC,iBAAA,CACA,0BACC,oBAAA,CACA,yCACC,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
